module.exports = __webpack_public_path__ + "static/media/markescermoni_div1_guld.36b72bda.jpg";